

<p-drawer header="&nbsp;" [(visible)]="visible" position="full" [blockScroll]="true" #drawerRef>
    <ng-template #headless>

        <p-selectbutton class="mobile-readmore-state-toggler" [unselectable]="false" (onOptionClick)="handleOptionChange($event)" [options]="stateOptions" [(ngModel)]="stateValue" optionLabel="label" optionValue="value" aria-labelledby="basic" [attr.data-testid]="'hotel-mobile-state-toggler'" />


        <p-button class="readmore-close-button" [rounded]="true" icon="" text="true" (click)="handleOnHide($event)" [attr.data-testid]="'hotel-drawer-close'">
            <span class="material-symbols-outlined">
                close
            </span>
        </p-button>


        <div class="row av-readmore-content">
            <div class="col-12 col-lg-6 p-0" [class.readmore-mobile-hidden]="stateValue == 'details'">
                <app-image-gallery1 #galleryRef context="hoteldetails" [preventLightbox]="true" [hotelCode]="hotelCode"></app-image-gallery1>
            </div>
            <div class="col-12 col-lg-6 hotel-details-right" [class.readmore-mobile-hidden]="stateValue == 'images'">
                <div class="hotel-data">

                    <div class="row">
                        <div class="col-12 mt-3">
                            <h2 class="hotel-name" [attr.data-testid]="'hotel-drawer-title'">{{hotelData?.name}}</h2>
                        </div>
                    </div>

                    <div class="amenities">
                        @for (amenity of hotelData?.amenities; track $index) {
                            <div  class="amenity">
                                @if (amenity == 'tv') {
                                    <span class="amenity-icon">
                                        <span class="material-symbols-outlined">tv</span>
                                    </span>
                                    <span class="amenity-text">{{"av.Television"|translate}}</span>
                                }
                                @if (amenity == 'kingbed') {
                                    <span class="amenity-icon">
                                        <span class="material-symbols-outlined">king_bed</span>
                                    </span>
                                    <span class="amenity-text">{{"av.KingBed"|translate}}</span>
                                }
                                @if (amenity == 'twin') {
                                    <span class="amenity-icon">
                                        <span class="material-symbols-outlined">single_bed</span>
                                        <span class="material-symbols-outlined">single_bed</span>
                                    </span>
                                    <span class="amenity-text">{{"av.TwoSingleBeds"|translate}}</span>
                                }
                                @if (amenity == 'ac') {
                                    <span class="amenity-icon">
                                        <span class="material-symbols-outlined">ac_unit</span>
                                    </span>
                                    <span class="amenity-text">{{"av.AC"|translate}}</span>
                                }
                            </div>
                        }
                    </div>

                    <div class="room-description" [attr.data-testid]="'hotel-drawer-description'" [innerHTML]="hotelData?.longDescription ?? hotelData?.description"></div>

                </div>

                <div class="row hotel-details-row">
                    <div class="col-6 hotel-details-column">

                        <h4>{{"av.HotelDetails"|translate}}</h4>
                        @if (hotelData.checkIn) {<div class="checkin">{{'cn.CheckIn' | translate}}: {{hotelData.checkIn}}</div>}
                        @if (hotelData.checkOut) {<div class="checkin">{{'cn.CheckOut' | translate}} {{hotelData.checkOut}}</div>}

                        <br><br>

                        {{contactDetails?.address}}, {{contactDetails?.zipCode}} {{contactDetails?.city}}, {{contactDetails?.country}}
                        <div>
                            {{"cn.Phone"|translate}}: <a href="{{'tel:'+contactDetails?.phone}}" [attr.data-testid]="'hotel-drawer-tel'">{{contactDetails?.phone}}</a><br>
                        </div>
                        <div>
                            {{"cn.Email"|translate}}: <a href="{{'mailto:'+contactDetails?.email}}" [attr.data-testid]="'hotel-drawer-email'">{{contactDetails?.email}}</a>
                        </div>
                    </div>
                    @if (contactDetails?.latLng) {
                        <div class="col-6">
                            <app-map [coordinates]="contactDetails?.latLng" [height]="'300px'"></app-map>
                        </div>
                    }
                </div>






            </div>
        </div>


    </ng-template>
</p-drawer>

